const BASE_PATH = '/v1/manu/agreement';

export const GetManuAgreementPath = (): string => BASE_PATH;

export const GetManuAgreementSearchPath = () => `${BASE_PATH}/search`;
export const GetManuAgreementSavePath = () => `${BASE_PATH}/orgunit-agreement`;
